<template>
  <div class="wrapper">
    <div class="top-bar">
      <div class="top-bar-left" @click="goBack()">
        <i class="el-icon-back"></i>详情
      </div>
    </div>
    <div class="wrapper_t">
      <div style="padding: 10px">
        <div class="activity-item">
          <div style="padding: 10px; width: 100%">
            <div>
              <div class="name">{{ activity.name }}</div>
              <div class="name">主讲：{{ activity.lecturer_name }}</div>
              <div>创建：{{ activity.teacher_name }}</div>
              <div>
                类型：{{
                  activity.type == 1
                    ? "听课评课"
                    : activity.type == 2
                    ? "集体备课"
                    : "教研会议"
                }}
              </div>
              <div>学校：{{ activity.from }}</div>
              <div>
                年级：{{ activity.gradeName }} 丨 学科：{{
                  activity.subjectName
                }}
              </div>
              <div>
                活动时间：{{ activity.startTime + " - " + activity.endTime }}
              </div>
              <div>备课课时：{{ activity.chapter_name }}</div>
            </div>
            <div>
              <div style="margin-top: 10px">会议日历</div>
              <div class="remote-list">
                <div
                  class="remote-item"
                  v-for="remote in remoteList"
                  :key="remote.id"
                >
                  <div>{{ remote.name }}</div>
                  <div>{{ remote.startTime }}</div>
                  <div>
                    {{
                      remote.state == 1
                        ? "待开始"
                        : remote.state == 2
                        ? "进行中"
                        : "已结束"
                    }}
                  </div>
                  <div style="margin-top: 10px">
                    <el-button
                      v-if="remote.state == 2"
                      size="mini"
                      type="primary"
                      @click="onMeeting"
                      >进入会议</el-button
                    >
                     <el-button
                      v-if="remote.state == 3"
                      size="mini"
                      type="primary"
                      @click="handleCommand(remote)"
                      >上传录像</el-button
                    >
                    <el-button
                      v-if="remote.state == 3 && remote.url"
                      size="mini"
                      type="info"
                      @click="onPlay(remote)"
                      >查看录像</el-button
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="course-list">
            <div
              class="course-item"
              v-for="(item, index) in courseList"
              :key="index"
            >
              <div class="course-item-info">
                <div style="flex: 1">
                  <label class="course-item-info-type">{{
                    item.type == 1 ? "一备" : item.type == 2 ? "二备" : "三备"
                  }}</label>
                  <label style="margin-left: 10px">{{
                    item.teacher_name
                  }}</label>
                  <label style="margin-left: 10px">{{
                    getDateStr(item.createtime)
                  }}</label>
                </div>
                <div
                  @click="showComment(item.course_uuid, 0)"
                  class="course-item-info-comment"
                >
                  回复
                </div>
              </div>
              <div class="course-item-file">
                包含资料：{{ item.material_sub_num }} ({{ item.name }})
              </div>
              <div>
                <div
                  v-for="(item_f, index_f) in item.fileList"
                  :key="'f' + item_f.id"
                >
                  <div class="file">
                    <div>
                      <img
                        v-if="
                          item_f.type == 'png' ||
                          item_f.type == 'jpg' ||
                          item_f.type == 'gif' ||
                          item_f.type == 'jpeg'
                        "
                        src="../../assets/images/course_2.0/图片.png"
                        class="course_homework"
                        alt=""
                      />
                      <img
                        v-if="item_f.type == 'pdf' || item_f.type == 'PDF'"
                        src="../../assets/images/course_2.0/pdf.png"
                        class="course_ppt"
                        alt=""
                      />
                      <img
                        v-if="
                          item_f.type == 'ppt' ||
                          item_f.type == 'pptx' ||
                          item_f.type == 'PPT' ||
                          item_f.type == 'PPTX'
                        "
                        src="../../assets/images/course_2.0/PPT.png"
                        class="course_ppt"
                        alt=""
                      />
                      <img
                        v-if="
                          item_f.type == 'doc' ||
                          item_f.type == 'DOC' ||
                          item_f.type == 'docx' ||
                          item_f.type == 'DOCX'
                        "
                        src="../../assets/images/course_2.0/word.png"
                        class="course_ppt"
                        alt=""
                      />
                      <img
                        v-if="item_f.type == 'xls' || item_f.type == 'xlsx'"
                        src="../../assets/images/course_2.0/excel.png"
                        class="course_ppt"
                        alt=""
                      />
                      <img
                        v-if="item_f.type == 'mp3' || item_f.type == 'MP3'"
                        src="../../assets/images/course_2.0/音频.png"
                        class="course_ppt"
                        alt=""
                      />
                      <img
                        v-if="
                          item_f.type == 'mp4' ||
                          item_f.type == 'MP4' ||
                          item_f.type == 'wmv' ||
                          item_f.type == 'WMV' ||
                          item_f.type == 'mpg' ||
                          item_f.type == 'MPG' ||
                          item_f.type == 'avi' ||
                          item_f.type == 'AVI' ||
                          item_f.type == 'swf' ||
                          item_f.type == 'SWF' ||
                          item_f.type == 'flv' ||
                          item_f.type == 'FLV'
                        "
                        src="../../assets/images/course_2.0/视频.png"
                        class="course_homework"
                        alt=""
                      />
                    </div>
                    <div class="file-name">{{ item_f.name }}</div>
                    <div class="file-btn" @click="download(item_f)">下载</div>
                    <div class="file-btn" @click="preview(item_f)">预览</div>
                  </div>
                  <div class="line"></div>
                </div>
                <div style="padding: 10px 20px">
                  <div
                    style="margin-bottom: 10px; padding: 5px"
                    v-for="(item_c, index_c) in item.comment_list"
                    :key="index_c"
                  >
                    <div class="line"></div>
                    <div style="display: flex; margin-top: 5px">
                      <div style="flex: 1; color: #409eff">
                        {{ item_c.teacher_name
                        }}{{ "  " + getDateStr(item_c.createtime) }}
                      </div>
                      <div
                        v-if="item_c.teacher_uuid == userInfo.uuid"
                        @click="deleteComment(item_c.uuid)"
                        class="course-item-info-comment"
                      >
                        删除
                      </div>
                      <div
                        style="margin-left: 20px"
                        @click="
                          showComment(item.course_uuid, item_c.uuid)
                        "
                        class="course-item-info-comment"
                      >
                        回复
                      </div>
                    </div>
                    <div style="margin-top: 5px">{{ item_c.content }}</div>
                    <div style="margin-left: 20px">
                      <div
                        style="margin-top: 10px"
                        v-for="(item_sc, index_sc) in item_c.comment_list"
                        :key="index_sc"
                      >
                        <div class="line"></div>
                        <div style="display: flex; margin-top: 5px">
                          <div style="flex: 1; color: #409eff">
                            {{ item_sc.teacher_name
                            }}{{ "  " + getDateStr(item_sc.createtime) }}
                          </div>
                          <div
                            v-if="item_sc.teacher_uuid == userInfo.uuid"
                            @click="deleteComment(item_sc.uuid)"
                            class="course-item-info-comment"
                          >
                            删除
                          </div>
                        </div>
                        <div style="margin-top: 5px">{{ item_sc.content }}</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-if="activity.state == 1" class="state state1">待开始</div>
          <div v-if="activity.state == 2" class="state state2">进行中</div>
          <div v-if="activity.state == 3" class="state state3">已结束</div>
        </div>
      </div>
    </div>
    <div class="wrapper_r">
      <div class="bt bt3" @click="addCourse1()">
        <div><i class="el-icon-upload"></i></div>
        <div>上传一备</div>
      </div>
      <div class="bt bt3" @click="addCourse2()">
        <div><i class="el-icon-upload"></i></div>
        <div>上传二备</div>
      </div>
      <div class="bt bt3" @click="addCourse3()">
        <div><i class="el-icon-upload"></i></div>
        <div>上传三备</div>
      </div>
      <div class="bt bt4" @click="toImage()">
        <div><i class="el-icon-camera"></i></div>
        <div>截图</div>
      </div>
    </div>

    <!-- 上传 -->
    <el-dialog
      :title="uploadTip"
      :visible.sync="fileDialogVisible"
      custom-class="dialogVisible_add_material"
      width="50%"
      :close-on-click-modal="false"
    >
      <div class="add_material_contnet">
        <div>
          <uploader
            :options="options_add_material"
            class="uploader-example"
            @file-progress="onFileProgress"
            @file-added="onFileAdded"
            @file-success="onFileSuccess"
            ref="uploader"
          >
            <uploader-unsupport></uploader-unsupport>
            <!-- <uploader-drop  v-if="add_material_list.length==0"> -->
            <uploader-drop>
              <!-- <uploader-btn single >选择文件</uploader-btn> -->
              <uploader-btn>选择文件</uploader-btn>
              <!-- <el-progress v-if="show_progress"  :percentage="ispercentage" ></el-progress> -->
            </uploader-drop>
            <uploader-list>
              <ul class="file-list" slot-scope="props">
                <li v-for="file in props.fileList" :key="file.id">
                  <uploader-file
                    v-if="!file.completed"
                    :class="'file_' + file.id"
                    ref="files"
                    :file="file"
                    :list="true"
                  ></uploader-file>
                  <!-- <div>{{file}}</div> -->
                </li>
                <!-- <div class="no-file" v-if="!props.fileList.length"><i class="nucfont inuc-empty-file"></i> 暂无待上传文件</div> -->
              </ul>
            </uploader-list>
            <div style="opacity: 0">列表</div>
          </uploader>

          <!--  -->
          <div style="display: flex; flex-wrap: wrap">
            <div
              class="add_course_info_content_box_content_item"
              @click="prew_material(item_f)"
              v-for="(item_f, index_f) in add_material_list"
              :key="index_f + 'f'"
            >
              <div class="add_course_info_content_box_content_item_img">
                <div
                  class="add_course_info_content_box_content_item_del"
                  @click.stop="
                    $confirm('确认删除？')
                      .then((_) => {
                        add_material_list.splice(index_f, 1);
                      })
                      .catch((_) => {})
                  "
                >
                  <img
                    src="../../assets/images/course_2.0/del_course_item.png"
                    alt=""
                  />
                </div>
                <img
                  v-if="
                    item_f.type == 'png' ||
                    item_f.type == 'jpg' ||
                    item_f.type == 'gif' ||
                    item_f.type == 'jpeg'
                  "
                  src="../../assets/images/course_2.0/图片.png"
                  class="add_course_info_content_box_content_item_img_homework"
                  alt=""
                />
                <img
                  v-if="item_f.type == 'pdf' || item_f.type == 'PDF'"
                  src="../../assets/images/course_2.0/pdf.png"
                  class="add_course_info_content_box_content_item_img_ppt"
                  alt=""
                />
                <img
                  v-if="
                    item_f.type == 'ppt' ||
                    item_f.type == 'pptx' ||
                    item_f.type == 'PPT' ||
                    item_f.type == 'PPTX'
                  "
                  src="../../assets/images/course_2.0/PPT.png"
                  class="add_course_info_content_box_content_item_img_ppt"
                  alt=""
                />
                <img
                  v-if="
                    item_f.type == 'doc' ||
                    item_f.type == 'DOC' ||
                    item_f.type == 'docx' ||
                    item_f.type == 'DOCX'
                  "
                  src="../../assets/images/course_2.0/word.png"
                  class="add_course_info_content_box_content_item_img_ppt"
                  alt=""
                />
                <img
                  v-if="item_f.type == 'xls' || item_f.type == 'xlsx'"
                  src="../../assets/images/course_2.0/excel.png"
                  class="add_course_info_content_box_content_item_img_ppt"
                  alt=""
                />

                <img
                  v-if="item_f.type == 'mp3' || item_f.type == 'MP3'"
                  src="../../assets/images/course_2.0/音频.png"
                  class="add_course_info_content_box_content_item_img_ppt"
                  alt=""
                />

                <img
                  v-if="
                    item_f.type == 'mp4' ||
                    item_f.type == 'MP4' ||
                    item_f.type == 'wmv' ||
                    item_f.type == 'WMV' ||
                    item_f.type == 'mpg' ||
                    item_f.type == 'MPG' ||
                    item_f.type == 'avi' ||
                    item_f.type == 'AVI' ||
                    item_f.type == 'swf' ||
                    item_f.type == 'SWF' ||
                    item_f.type == 'flv' ||
                    item_f.type == 'FLV'
                  "
                  src="../../assets/images/course_2.0/视频.png"
                  class="add_course_info_content_box_content_item_img_homework"
                  alt=""
                />
              </div>
              <div class="add_course_info_content_box_content_item_txt">
                {{ item_f.name || item_f.title || "" }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="fileDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="save_add_material()">确 定</el-button>
      </span>

      <!-- <homeTimetable :from="'course'" :chooseday_index='chooseday_index' :arr_to_classtable='arr_to_classtable' v-if="dialogVisible_classtable"></homeTimetable> -->
    </el-dialog>
    <!-- 预览 -->
    <el-dialog
      :title="'预览：' + (prew_content.name || prew_content.title)"
      :visible.sync="dialogVisible_previewData"
      width="50%"
      custom-class="sign_course_edit_rich_guide_dia_prew"
    >
      <previewData
        v-if="dialogVisible_previewData"
        :prew_type="prew_type"
        :prew_content="prew_content"
      ></previewData>
    </el-dialog>

    <!-- 选择备课包 -->
    <el-dialog
      :title="'选择备课包(' + resourceTypeName + ')'"
      :visible.sync="resourceDialogVisible"
      width="50%"
    >
      <div style="position: relative">
        <el-button
          type="success"
          style="position: absolute; right: 40px; top: -40px"
          size="mini"
          @click="toResource"
          >去上传</el-button
        >
        <div
          class="resource-item"
          v-for="(item, index) in list_resource"
          :key="index"
        >
          <div style="flex: 1">
            <div>{{ item.name }}</div>
            <div style="margin-top: 3px">
              时间：{{ item.createtime }} 创建人：{{ item.from }}-{{
                item.teacher_name
              }}
              资料：{{ item.material_sub_num }}
            </div>
          </div>
          <div>
            <el-button
              type="primary"
              size="mini"
              round
              @click="selectCourse(item)"
              >选择</el-button
            >
          </div>
        </div>
        <div v-if="list_resource.length == 0" class="course_card_empty"></div>
        <div style="text-align: right" v-if="total > 10">
          <el-pagination
            background
            layout="prev, pager, next"
            @current-change="changePage"
            :page-size="10"
            :current-page="pageNum"
            :total="total"
          >
          </el-pagination>
        </div>
      </div>
    </el-dialog>

    <!-- 回复 -->
    <el-dialog title="回复" :visible.sync="commentDialogVisible" width="40%">
      <div>
        <el-form ref="form" label-width="80px">
          <el-form-item label="回复内容">
            <el-input type="textarea" v-model="commentText"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="onComment">回复</el-button>
            <el-button
              @click="
                commentText = '';
                commentDialogVisible = false;
              "
              >取消</el-button
            >
          </el-form-item>
        </el-form>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import previewData from "../../components/common_module/preview_data.vue";
import userinfoVue from "../home/userinfo.vue";
import ScreenShort from "js-web-screen-shot";
export default {
  components: { previewData },
  data() {
    return {
      userInfo: "",
      currTime: new Date(),
      gradeList: [
        { id: 11, name: "小学一年级" },
        { id: 12, name: "小学二年级" },
        { id: 13, name: "小学三年级" },
        { id: 14, name: "小学四年级" },
        { id: 15, name: "小学五年级" },
        { id: 16, name: "小学六年级" },
        { id: 21, name: "初一" },
        { id: 22, name: "初二" },
        { id: 23, name: "初三" },
        { id: 31, name: "高一" },
        { id: 32, name: "高二" },
        { id: 33, name: "高三" },
      ],
      subjectList: [],
      resourceDialogVisible: false,
      fileDialogVisible: false,
      commentDialogVisible: false,
      commentText: "",
      activityCourseUuid: "",
      commentParentUuid: "0",
      courseCommentList: [],

      add_material_list: [],
      options_add_material: {
        target: "",
        testChunks: false,
        allowDuplicateUploads: false,
        attrs: {
          accept: "*",
        },
        headers:{
          token: sessionStorage.token,
          key: sessionStorage.keyValue
        },
        chunkSize: "1024000",
      },
      show_progress: false,
      prew_content: "",
      prew_type: "",
      dialogVisible_previewData: false,
      activity: {},
      fileList: [],
      remoteList: [],
      courseList: [],
      resourceTypeName: "",

      list_resource: [],
      total: 0,
      popover_sort_show: false,
      sort_time: "全部",
      sort_type: "时间最新",
      order: "descending",
      sort: "createtime",
      startTime_sort: "",
      endTime_sort: "",
      pageNum: 1,
      pageSize: 10,
      type_first: "",

      uploadType: 0,
      uploadTip: "上传资料",
      documentExt: ["doc", "docx", "xls", "xlsx", "pptx", "pdf"],
      videoExt: ["mp4"],
      uplodateRemote:null
    };
  },
  //监听路由变化 控制首页背景图
  watch: {},
  created() {
    if (this.$route.params.uuid) {
      this.activity.uuid = this.$route.params.uuid;
    }

    this.options_add_material.target =
      sessionStorage.url + "/proxy2/cloud/upload/zoneupload?convert_now=1";
  },

  beforeMount() {},
  mounted() {
    this.userInfo = JSON.parse(sessionStorage.userInfo);

    this.getSubject();
  },
  methods: {
    getSubject() {
      this.axios.post(`/teacher/subject/getsubject`, {}).then((res) => {
        this.subjectList = res.data.data;
        this.getData();
      });
    },
    goBack() {
      this.$router.push("/research/" + this.$route.params.type);
    },
    getData() {
      let formData = {
        uuid: this.activity.uuid,
      };
      this.axios
        .post(`/teacher/research/getTeachActivity`, formData)
        .then((res) => {
          var data = res.data.data;
          var element = data.teachActivity;
          var startTime = new Date(element.start_time);
          var endTime = new Date(element.end_time);
          if (startTime > this.currTime) {
            element.state = 1;
          } else if (endTime < this.currTime) {
            element.state = 3;
          } else {
            element.state = 2;
          }
          element.startTime = this.format(startTime);
          element.endTime = this.format(endTime);
          element.gradeName = this.gradeList.find(
            (x) => x.id == element.grade
          ).name;
          element.subjectName = this.subjectList.find(
            (x) => x.code == element.subject_code
          ).name;
          //element.chapter_code ="216897,216906,216907,216908,216909,216910,216913,216914,216915,216916,216911,216945";
          this.activity = element;
          data.fileList.forEach((x) => {
            x.type = x.ext;
          });
          this.fileList = data.fileList;
          data.activityRemoteList.forEach((x) => {
            var remoteStartTime = new Date(x.start_time);
            var remoteEndTime = new Date(x.end_time);
            x.startTime = this.format(remoteStartTime);
            if (remoteStartTime > this.currTime) {
              x.state = 1;
            } else if (remoteEndTime < this.currTime) {
              x.state = 3;
            } else {
              x.state = 2;
            }
          });
          this.remoteList = data.activityRemoteList;
          this.processing(data.activityCourseList);
          var commentList = data.activityCourseCommentList;
          data.activityCourseList.forEach((x) => {
            console.log(x);
            var cList = commentList.filter(
              (y) =>
                y.teach_activity_course_uuid == x.course_uuid &&
                y.parent_uuid == 0
            );
            cList.forEach((z) => {
              z.comment_list = commentList.filter(
                (u) => u.parent_uuid == z.uuid
              );
            });
            x.comment_list = cList;
          });
          this.courseList = data.activityCourseList;
          console.log(this.courseList);
          //this.getOtherFile();
        });
    },
    //处理数据
    processing(list) {
      for (var i = 0; i < list.length; i++) {
        try {
          list[i].b_uuid = JSON.parse(list[i].content).b.uuid.length;
          list[i].b_f = JSON.parse(list[i].content).b.f;
          list[i].m_uuid = JSON.parse(list[i].content).m.uuid.length;
          list[i].m_f = JSON.parse(list[i].content).m.f.length;
          list[i].a_f = JSON.parse(list[i].content).a.f;
          list[i].a_uuid = JSON.parse(list[i].content).a.uuid.length;
          list[i].createtime = list[i].createtime.split(" ")[0];
          list[i].m_file = JSON.parse(list[i].content).m.f;
          list[i].fileList = list[i].b_f.concat(list[i].a_f).concat(list[i].m_file);
        } catch (error) {
          list[i].b_uuid = 0;
          list[i].b_f = [];
          list[i].a_uuid = 0;
          list[i].a_f = 0;
          list[i].m_uuid = 0;
          list[i].createtime = list[i].createtime.split(" ")[0];
          list[i].fileList = [];
        }
      }
    },
    getActivityCourse() {
      this.axios
        .post(`/teacher/research/getActivityOtherFileList`, {
          uuid: this.activity.uuid,
        })
        .then((res) => {
          var fileList = res.data.data;
          fileList.forEach((x) => {
            x.type = x.ext;
            x.create_time = this.format(new Date(x.createtime * 1000));
          });
          this.otherFileList = fileList;
        });
    },
    showFile() {
      this.add_material_list = [];
      this.uploadType = 0;
      this.uploadTip = "上传录像";
      this.fileDialogVisible = true;
    },
    deleteActivityFile(uuid) {
      this.$confirm("确定删除文件?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.axios
            .post(`/teacher/research/deleteActivityFile`, { uuid: uuid })
            .then((res) => {
              this.getOtherFile();
            });
        })
        .catch(() => {});
    },
    handleCommand(remote) {
      this.uplodateRemote = remote;
      this.uploadTip = "上传录像";
      this.uploadType = 1;
      this.add_material_list = [];
      this.fileDialogVisible = true;
    },
    //生成资料
    save_add_material() {
      if (this.add_material_list.length == 0) {
        this.$message({
          message: "请上传",
          type: "error",
          duration: 1500,
          showClose: true,
        });
        return;
      }
      if (this.uploadType == 0) {
        this.saveFile();
      } else {
        console.log(this.add_material_list.length);
        if (this.add_material_list.length > 1) {
          this.$message({
            message: "只能上传一个文件",
            type: "error",
            duration: 1500,
            showClose: true,
          });
          return;
        }
        this.updateVideo(this.add_material_list[0].url);
      }
    },
    saveFile() {
      var formData = new FormData();
      formData.append("teach_activity_uuid", this.activity.uuid);
      formData.append("teacher_uuid", this.activity.teacher_uuid);
      formData.append("fileJson", JSON.stringify(this.add_material_list));
      this.axios.post("/teacher/research/saveFile", formData).then((res) => {
        if (res.data.code == 1) {
          this.$message({
            message: res.data.msg,
            type: "success",
            duration: 1500,
            showClose: true,
          });

          // return
          this.add_material_list = [];
          this.fileDialogVisible = false;
          this.getOtherFile();
        } else {
          this.$message({
            message: res.data.msg,
            type: "error",
            duration: 1500,
            showClose: true,
          });
        }
      });
    },
    updateVideo(url) {
      var formData = new FormData();
      formData.append("uuid", this.uplodateRemote.uuid);
      if (this.uploadType == 1) {
        formData.append("url", url);
      } 
      this.axios.post("/teacher/research/updateRemoteUrl", formData).then((res) => {
        if (res.data.code == 1) {
          this.$message({
            message: res.data.msg,
            type: "success",
            duration: 1500,
            showClose: true,
          });

          // return
          this.fileDialogVisible = false;
          this.uplodateRemote.url = sessionStorage.url  + url;
        } else {
          this.$message({
            message: res.data.msg,
            type: "error",
            duration: 1500,
            showClose: true,
          });
        }
      });
    },
    // 上传回调
    onFileProgress(rootFile, file, chunk) {
      if (Math.floor((chunk.endByte / file.size) * 100) > this.ispercentage) {
        this.ispercentage = Math.floor((chunk.endByte / file.size) * 100);
        //  console.log(this.ispercentage)
      }
    },
    onFileAdded(file) {
      // console.log(file)
      this.ispercentage = 0;
      if (
        (file.fileType.indexOf("presentation") != -1 ||
          file.fileType.indexOf("powerpoint") != -1) &&
        file.size / 1024 / 1024 >= 100
      ) {
        file.pause();
        this.$message({
          duration: 3000,
          type: "error",
          message: "ppt大小不能超过100M!",
        });
      }
      if (this.uploadType == 0) {
        if (this.documentExt.indexOf(this.getFileExt(file.file.name)) == -1) {
          file.pause();
          this.$message({
            duration: 3000,
            type: "error",
            message: "文件类型仅限（pdf、pptx、word、excel）!",
          });
          return;
        }
      } else {
        if (this.videoExt.indexOf(this.getFileExt(file.file.name)) == -1) {
          file.pause();
          this.$message({
            duration: 3000,
            type: "error",
            message: "视频类型仅限mp4!",
          });
          return;
        }
      }
      this.show_progress = true;
    },
    onFileSuccess(rootFile, file, response, chunk) {
      this.ispercentage = 100;
      this.show_progress = false;

      if (JSON.parse(response).code == 1) {
        // console.log(file)

        // console.log(response)

        try {
          this.upFile_src = JSON.parse(response).data.url;
        } catch (error) {
          this.upFile_src = response;
        }
        this.upFile_type =
          file.name.split(".")[file.name.split(".").length - 1];
        this.ispercentage = 0;
        this.add_material_list.push({
          name: file.name,
          url: this.upFile_src,
          type: file.name.split(".")[file.name.split(".").length - 1],
          id: file.id,
        });
      } else {
        // file-removed(file)
        this.$message({
          type: "error",
          message: JSON.parse(response).msg,
          duration: 1500,
          showClose: true,
        });
      }

      // console.log(chunk)
      // this.$router.push({ path: "/sign_data" });
    },
    download_material(item) {
      console.log(item.url);
      var xhr = new XMLHttpRequest();
      xhr.open(
        "GET",
         item.url.indexOf("http://") > -1 || item.url.indexOf("https://") > -1
          ? item.url
          : sessionStorage.url + item.url,
        true
      );
      xhr.responseType = "blob";
      xhr.onload = function () {
        if (xhr.status === 200) {
          var link = document.createElement("a");
          var body = document.querySelector("body");
          link.href = window.URL.createObjectURL(xhr.response);
          link.download = item.name;
          link.style.display = "none";
          // link.target = "_blank";
          body.appendChild(link);
          link.click();
          body.removeChild(link);
          window.URL.revokeObjectURL(link.href);
        }
      };
      xhr.send();
    },
    prew_material(item) {
      // return
      if (
        item.type == "mp4" ||
        item.type == "MP4" ||
        item.type == "avi" ||
        item.type == "AVI" ||
        item.type == "flv" ||
        item.type == "FLV" ||
        item.type == "SWF" ||
        item.type == "swf" ||
        item.type == "mpg" ||
        item.type == "MPG" ||
        item.type == "wmv" ||
        item.type == "WMV"
      ) {
        this.prew_type = "mp4";
      } else if (
        item.type == "png" ||
        item.type == "PNG" ||
        item.type == "jpg" ||
        item.type == "JPG" ||
        item.type == "jpeg" ||
        item.type == "JPEG"
      ) {
        this.prew_type = "img";
      } else if (
        item.type == "doc" ||
        item.type == "DOC" ||
        item.type == "docx" ||
        item.type == "DOCX" ||
        item.type == "ppt" ||
        item.type == "PPT" ||
        item.type == "pptx" ||
        item.type == "PPTX" ||
        item.type == "xls" ||
        item.type == "xlsx"
      ) {
        this.prew_type = "ppt";
      } else if (item.type == "mp3" || item.type == "MP3") {
        this.prew_type = "mp3";
      } else if (item.type == "pdf" || item.type == "PDF") {
        this.prew_type = "pdf";
      }

      this.prew_content = item;
      this.dialogVisible_previewData = true;
    },
    download(item) {
      this.download_material(item);
    },
    preview(item) {
       item.url = item.url.indexOf("http://") > -1 || item.url.indexOf("https://") > -1
          ? item.url
          : sessionStorage.url + item.url;
      this.prew_material(item);
    },
    addCourse1() {
      this.resourceTypeName = "一备";
      this.type_first = "my";
      this.pageNum = 1;
      this.get_sourceBag();
    },
    addCourse2() {
      this.resourceTypeName = "二备";
      this.type_first = "school";
      this.pageNum = 1;
      this.get_sourceBag();
    },
    addCourse3() {
      this.resourceTypeName = "三备";
      this.type_first = "cloud";
      this.pageNum = 1;
      this.get_sourceBag();
    },
    toImage() {
      const screenShotHandler = new ScreenShort({
        enableWebRtc: false, //是否显示选项框
        level: 99, //层级级别
        completeCallback: this.callback,
        closeCallback: this.closeFn,
      });
    },
    format(dat) {
      //获取年月日，时间
      var year = dat.getFullYear();
      var mon =
        dat.getMonth() + 1 < 10
          ? "0" + (dat.getMonth() + 1)
          : dat.getMonth() + 1;
      var data = dat.getDate() < 10 ? "0" + dat.getDate() : dat.getDate();
      var hour = dat.getHours() < 10 ? "0" + dat.getHours() : dat.getHours();
      var min =
        dat.getMinutes() < 10 ? "0" + dat.getMinutes() : dat.getMinutes();
      var seon =
        dat.getSeconds() < 10 ? "0" + dat.getSeconds() : dat.getSeconds();

      var newDate = year + "-" + mon + "-" + data + " " + hour + ":" + min;
      return newDate;
    },
    timeStr() {
      let startTime = new Date(this.activity.start_time);
      let endTime = new Date(
        startTime.getTime() + this.activity.duration * 3600 * 1000
      );
      let now = new Date();
      if (now.getTime() < startTime.getTime()) {
        var dateDiff = startTime.getTime() - now.getTime();
        var day = Math.floor(dateDiff / (24 * 3600 * 1000));
        if (day > 0) {
          return "距开始：" + day + "天";
        } else {
          let leave1 = dateDiff % (24 * 3600 * 1000); //计算天数后剩余的毫秒数
          let hours = Math.floor(leave1 / (3600 * 1000)); //计算出小时数
          //计算相差分钟数
          let leave2 = leave1 % (3600 * 1000); //计算小时数后剩余的毫秒数
          let minutes = Math.floor(leave2 / (60 * 1000)); //计算相差分钟数
          let leave3 = leave2 % (60 * 1000); //计算分钟数后剩余的毫秒数
          let seconds = Math.round(leave3 / 1000);

          return (
            "距开始：" +
            (hours > 10 ? hours : "0" + hours) +
            ":" +
            (minutes > 10 ? minutes : "0" + minutes) +
            ":" +
            (seconds > 10 ? seconds : "0" + seconds)
          );
        }
        return "";
      } else if (now.getTime() <= endTime.getTime()) {
        return "进行中";
      } else if (now.getTime() > endTime.getTime()) {
        if (this.activity.video_url) {
          return "";
        } else {
          return "等待录像上传";
        }
      }
      return "";
    },
    getDateStr(time) {
      return this.format(new Date(time));
    },
    getFileExt(name) {
      var ext = name.substring(name.lastIndexOf(".") + 1);
      return ext.toLowerCase();
    },
    //分页 换页
    changePage(pageNum) {
      this.pageNum = pageNum;
      this.get_sourceBag();
    },

    //请求资源全家桶
    get_sourceBag() {
      if (!this.activity.chapter_code) {
        this.$message("请先设置备课课时");
        return;
      }
      let formData = new FormData();
      let url = "";
      formData.append("flag", this.type_first + "_course");
      formData.append("order", this.order);
      formData.append("sort", this.sort);
      formData.append("current_page", this.pageNum);
      formData.append("page_size", this.pageSize);
      formData.append("chapter_code", this.activity.chapter_code);
      if (this.type_first == "cloud") {
        url = "/teacher/subject/sourcebag";
      } else {
        url = "/school/bag/sourceBag";
      }
      this.axios.post(url, formData).then((res) => {
        if (res.data.code == 1) {
          if (this.type_first == "cloud") {
            this.total = res.data.data.total;
          } else {
            this.total = res.data.data.count;
          }
           res.data.data.data.forEach(x =>{
            if (this.type_first == "cloud" || this.type_first == "school") {
               x.course_uuid = x.uuid;
            }
          });
          this.list_resource = res.data.data.data;
          this.resourceDialogVisible = true;
          console.log(this.list_resource);
        } else {
          this.$message({
            type: "error",
            message: res.data.msg,
            duration: 1500,
            showClose: true,
          });
        }
      });
    },
    selectCourse(item) {
      let activityCourseformData = new FormData();
      activityCourseformData.append("teach_activity_uuid", this.activity.uuid);
      activityCourseformData.append(
        "course_uuid",
        this.type_first == "my" ? item.course_uuid : item.uuid
      );
      activityCourseformData.append(
        "type",
        this.type_first == "my" ? 1 : this.type_first == "school" ? 2 : 3
      );
       activityCourseformData.append(
        "course_data",
        JSON.stringify(item)
      );
      this.axios
        .post("/teacher/research/addActivityCourse", activityCourseformData)
        .then((res) => {
          if (res.data.code == 1) {
            this.$message({
              type: "success",
              message: res.data.msg,
              duration: 1500,
              showClose: true,
            });
            this.resourceDialogVisible = false;
            this.getData();
          } else {
            this.$message({
              type: "error",
              message: res.data.msg,
              duration: 1500,
              showClose: true,
            });
          }
        });
    },
    showComment(uuid, parentUuid) {
      this.activityCourseUuid = uuid;
      this.commentParentUuid = parentUuid;
      this.commentDialogVisible = true;
    },
    onComment() {
      let formData = new FormData();
      formData.append("teach_activity_uuid", this.activity.uuid);
      formData.append("teach_activity_course_uuid", this.activityCourseUuid);
      formData.append("content", this.commentText);
      formData.append("parent_uuid", this.commentParentUuid);
      this.axios
        .post("/teacher/research/addActivityCourseComment", formData)
        .then((res) => {
          if (res.data.code == 1) {
            this.$message({
              type: "success",
              message: res.data.msg,
              duration: 1500,
              showClose: true,
            });
            this.commentText = "";
            this.commentDialogVisible = false;
            this.getData();
          } else {
            this.$message({
              type: "error",
              message: res.data.msg,
              duration: 1500,
              showClose: true,
            });
          }
        });
    },
    deleteComment(uuid) {
      this.$confirm("确定删除该回复?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.axios
            .post(`/teacher/research/deleteActivityCourseComment`, {
              uuid: uuid,
            })
            .then((res) => {
              this.getData();
            });
        })
        .catch(() => {});
    },
    onMeeting() {
      this.$message("待接入");
    },
    onPlay(remote) {
      //this.$message("待接入");
      this.prew_material({
        type: 'mp4',
        url: remote.url,
        ext: 'mp4',
        name: remote.name + '录像'
      });
    },
    toResource() {
      this.po_up_title = "新增备课包";
      sessionStorage.removeItem("teaching_text_e");
      sessionStorage.removeItem("course_content_course_name");
      sessionStorage.removeItem("teaching_text_name");
      sessionStorage.removeItem("teaching_text_name_e");
      sessionStorage.removeItem("guidance_text_e");
      sessionStorage.removeItem("guidance_text");
      sessionStorage.removeItem("guidance_text_uuid");
      sessionStorage.removeItem("teaching_text_uuid");
      sessionStorage.removeItem("teaching_text");
      sessionStorage.removeItem("course_content");
      sessionStorage.removeItem("course_content_guide_name");
      sessionStorage.removeItem("course_content_guide_json");
      sessionStorage.removeItem("course_content_type");

      let str = this.activity.chapter_code;

      let obj = {
        book_code: '',
        chapter_code: str,
        courseName: "新增备课包",
        chapter_name: this.chapter_name,
      };

      sessionStorage.course_add_type = "new";
      sessionStorage.course_name_new = "新增备课包";
      sessionStorage.course_new_obj = JSON.stringify(obj);
      this.$router.push({
        path: "/course/sign_course_new",
        query: {
          name: "新增备课包",
          label: this.homework_label_id,
          from: "research",
          research_uuid: this.activity.uuid
        },
      });
    },
  },
};
</script>

<style scoped>
.wrapper {
  margin: 0px auto;
  height: calc(100vh - 142px);
  overflow: auto;
  width: 75vw;
  padding-top: 10px;
  position: relative;
}
.wrapper_t {
  width: calc(100% - 8vw);
  height: calc(100% - 90px);
  background: white;
  border-radius: 20px;
  overflow-y: auto;
  overflow-x: hidden;
  margin-top: 20px;
}
.wrapper_r {
  position: absolute;
  right: 20px;
  top: 100px;
}
.wrapper_r .bt {
  border: #dcdfe6;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12), 0 0 6px rgba(0, 0, 0, 0.04);
  font-size: 14px;
  width: 60px;
  height: 60px;
  margin-bottom: 30px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border-radius: 8px;
  background-color: white;
  padding: 5px;
  cursor: pointer;
}
.wrapper_r i {
  font-size: 18px;
}
.wrapper_r .bt1 {
  color: #409eff;
}
.wrapper_r .bt2 {
  color: #e6a23c;
}
.wrapper_r .bt3 {
  color: #f56c6c;
}
.wrapper_r .bt4 {
  color: #67c23a;
}
.wrapper_r .bt5 {
  color: #909399;
}
.bar {
  background-color: white;
  padding: 10px;
  font-size: 14px;
  display: flex;
}
.bar span {
  margin-left: 20px;
}
.bar .right {
  flex: 1;
  text-align: right;
  color: #409eff;
  cursor: pointer;
}
.top-bar {
  padding: 8px 16px;
  height: 44px;
  overflow: hidden;
  background-color: white;
  display: flex;
  align-items: center;
}

.top-bar-left {
  line-height: 44px;
  left: 16px;
  cursor: pointer;
}
.top-bar-right {
  flex: 1;
  text-align: right;
  color: #409eff;
  cursor: pointer;
}
.top-bar-right span {
  margin-left: 20px;
}
.activity-item {
  border: 1px solid #e4e7ed;
  border-radius: 10px;
  position: relative;
  font-size: 14px;
}
.activity-item .name {
  color: #303133;
  font-weight: bold;
}
.activity-item .state {
  position: absolute;
  right: 0;
  top: 0;
  border-bottom-left-radius: 20px;
  border-top-right-radius: 10px;
  padding: 5px 15px;
  font-size: 12px;
}
.activity-item .state1 {
  color: #409eff;
  border: 1px solid #409eff;
}
.activity-item .state2 {
  color: white;
  background-color: #409eff;
}
.activity-item .state3 {
  color: white;
  background-color: #909399;
}
.activity-item .op {
  background-color: #f2f6fc;
  display: flex;
  padding: 10px;
}
.activity-item .op span {
  color: #409eff;
  margin-left: 20px;
  cursor: pointer;
}
.activity-item .op i {
  font-size: 18px;
}
.activity-item .file {
  display: flex;
  padding: 10px;
  align-items: center;
}
.activity-item .file .file-name {
  flex: 1;
  color: #303133;
  margin-left: 5px;
}
.activity-item .file .file-btn {
  color: #409eff;
  margin-left: 20px;
  cursor: pointer;
}
.activity-item .line {
  border-top: 1px solid #ebeef5;
}
.add_course_info_content_box_content_item_img_homework {
  display: block;
  width: 26px;
  height: 22px;
}
.add_course_info_content_box_content_item_img_ppt {
  display: block;
  width: 22px;
  height: 26px;
}
.note-title {
  font-weight: bold;
  color: #409eff;
}
.comment-item {
  border: 1px dashed #dcdfe6;
  padding: 10px;
  font-size: 14px;
  margin-bottom: 10px;
}
.activity-item .file-1 {
  display: block;
  width: 26px;
  height: 22px;
}
.activity-item .file-2 {
  display: block;
  width: 22px;
  height: 26px;
}
.remote-list {
  display: flex;
  flex-wrap: wrap;
  margin-top: 5px;
}
.remote-item {
  border: 1px solid #ebeef5;
  margin-right: 10px;
  margin-bottom: 10px;
  height: 120px;
  width: 180px;
  padding: 10px;
  color: #000;
}
.resource-item {
  padding: 8px;
  border: 1px solid #ebeef5;
  margin-bottom: 5px;
  display: flex;
  align-items: center;
}
.course-list {
}
.course-item {
  border-top: 2px solid #606266;
  margin-bottom: 10px;
}
.course-item-info {
  display: flex;
  padding: 10px;
}
.course-item-info-type {
  border: 1px solid #e4e7ed;
  padding: 3px 8px;
  color: #409eff;
  border-radius: 2px;
}
.course-item-info-comment {
  cursor: pointer;
  color: #409eff;
}
.course-item-file {
  background-color: #c0c4cc;
  color: #000;
  padding: 8px;
}

.uploader-drop {
  border: 0 !important;
  background-color: transparent;
  padding: 0;
  margin: 0 0 10px 0;
}
.uploader-btn {
  height: 36px !important;
  background: #ff9b36 !important;
  border-radius: 10px !important;
  line-height: 36px;
  padding: 0 20px;
  margin: 0;
  border: 0;
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #ffffff;
}
.play-container-bottom {
  width: 100%;
  height: 60px;
  background: #303133;
  border-radius: 0px 0px 10px 10px;
  font-size: 14px;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
}
.play-container-bottom-time {
  font-weight: 400;
  font-size: 20px;
  color: rgb(255, 255, 255);
  font-style: normal;
  letter-spacing: 0px;
  line-height: 29px;
  text-decoration: none;
  margin-right: 16px;
}
.edit_material_item_type_name {
  margin-bottom: 20px;
}
.add_course_info_content_box_content_item {
  margin: 0 21px 21px 0;
  cursor: pointer;
  position: relative;
}
.send_to_type {
  position: absolute;
  left: 0px;
  top: 0px;
  z-index: 9;
  width: 36px;
  height: 24px;
  border-radius: 12px 0 8px 0;
  background: #ff9b36;
  color: white;
  line-height: 24px;
  text-align: center;
  cursor: pointer;
}
.add_course_info_content_box_content {
  display: flex;
  flex-wrap: wrap;
  margin: 30px 0 0px 0;
}
.add_course_info_content_box_content_item_img {
  width: 120px;
  height: 100px;
  background: #ffffff;
  border: 1px solid #ff9b36;
  border-radius: 12px;
  position: relative;
}
.add_course_info_content_box_content_item_img_homework {
  display: block;
  width: 43px;
  height: 35px;
  margin: 32px auto;
}
/* .add_course_info_content_box_content_item_img_homework{
      display: block;
      width: 43px;
      height: 35px;
      margin: 32px auto;
    } */
.add_course_info_content_box_content_item_img_ppt {
  display: block;
  width: 42px;
  height: 42px;
  margin: 28px auto;
}
.add_course_info_content_box_content_item_img_teaching {
  display: block;
  width: 44px;
  height: 47px;
  margin: 26px auto;
}

.add_course_info_content_box_content_item_txt {
  width: 120px;
  /* height: 35px; */
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
  line-height: 35px;
  overflow: hidden;
  text-overflow: ellipsis;
  text-align: center;
}
.add_course_info_content_box_content_item_del {
  width: 13px;
  height: 13px;
  cursor: pointer;
  position: absolute;
  right: -6px;
  top: -6px;
}
.add_course_info_content_box_content_item_del img {
  display: block;
  width: 13px;
  height: 13px;
}
.el-dropdown-link {
  cursor: pointer;
  color: #409eff;
  font-size: 16px;
}
.course_card_empty {
  background: url(../../assets/images/course_2.0/老师.png);
  width: 100%;
  height: 260px;
  background-repeat: no-repeat;
  background-position: 50% 50%;
  background-size: 200px auto;
}
.course_homework {
  display: block;
  width: 26px;
  height: 22px;
}
.course_ppt {
  display: block;
  width: 22px;
  height: 26px;
}
</style>
